import { render, staticRenderFns } from "./PenIcon.vue?vue&type=template&id=0d1a68fc&lang=pug&"
import script from "./PenIcon.vue?vue&type=script&lang=js&"
export * from "./PenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports